














































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { InsertReportPdf, GetReportPdfStandardList } from "@/api/reportSetting";
@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  pdfFormData: any = {
    standard: "A4",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
    defaultFontSize: 11
  };
  saveLoading = false;
  rules: any = {
    reportName: [
      { required: true, message: "请输入报表名称", trigger: "blur" }
    ],
    standardId: [
      {
        type: "number",
        required: true,
        message: "请选择纸张规格",
        trigger: "change"
      }
    ]
  };
  standardList: any = []; //打印纸规格下拉框

  created() {
    this.initSelect();
  }

  async initSelect() {
    let res = await GetReportPdfStandardList();
    this.standardList = res.objects;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.saveLoading = true;
        let res = await InsertReportPdf(this.pdfFormData);
        if (res.code == 2000) {
          this.$emit("save-success");
          this.$emit("input", false);
        }
        this.saveLoading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/reportSetting/add.vue